function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import getImageUrl from './image-helpers';
import { classNamesFor } from '../utils/classNames';
import formatStaticUrl from '../utils/formatStaticUrl';
import MediaFrame from '../MediaFrame';
var cx;

var getStaticImageSrc = function getStaticImageSrc(filename, config) {
  return "".concat(formatStaticUrl(config)).concat(filename);
};

var getFirstNonZeroParentWidth = function getFirstNonZeroParentWidth(el) {
  if (!el) return undefined;
  if (el.clientWidth > 1) return el.clientWidth;
  return getFirstNonZeroParentWidth(el.parentElement);
};

var isPercentage = function isPercentage(width) {
  return typeof width === 'string' && width.slice(-1) === '%';
};

var isPx = function isPx(width) {
  return typeof width === 'number' || /px$/.test(width);
};

var isVw = function isVw(width) {
  return /vw$/.test(width);
};

var getPxWidthFromVw = function getPxWidthFromVw(width) {
  var percent = parseInt(width, 10) / 100;
  return document.body.clientWidth * percent;
};

var resolvePxWidth = function resolvePxWidth(width) {
  var result = parseInt(width, 10);
  var resolvedWidth = Number.isNaN(result) ? undefined : result;
  return resolvedWidth;
};

var getPxWidthFromPercent = function getPxWidthFromPercent(parentWidth, width) {
  var decimalPercentValue = parseInt(width, 10) / 100;
  var adjustedWidth = parentWidth * decimalPercentValue;
  return adjustedWidth;
};
/**
 * The Image component is a primitive component which applies progressive
 * image loading for images which are supported by Akamai's image manager service.
 * This component will render images server side but with limitations. The width
 * should always be set if it is known and static.
 *
 * - [Akamai Image Manager Overview Slides](https://docs.google.com/presentation/d/124BlW6Rzl230LjyJG6LHB9ko4QbWosQsrZN48P1Hpck/edit#slide=id.g443e196568_0_0)
 * - [Akamai Image Manager Client Usage](https://docs.google.com/presentation/d/1I9X1UecstHTdtOwJH9Ep3IMFnDpjnGRKmXJX8Osg7qI/edit#slide=id.g5645935a08_0_8)
 *
 * ## Related Components
 * - [Media](../Media/README.md)
 * - [MediaFrame](../MediaFrame/README.md)
 *
 * ## Configuration
 *
 * ```javascript
 *  import { Image } from '@sie/web-common-react-components';
 *
 * Image.configure({
 *   // isSsr will be set automatically but if it's not set correctly
 *   // it may be set explicitly. It is needed due to server rendering
 *   // not knowing the dimensions of the browsers screen and will need
 *   // to alter what it can render depending on the image
 *   isSsr: false,
 *   version: 'v0',
 *   npEnvironment: 'e1-np',
 *   // can use a template to use the above config values (dynamic) or
 *   // specify the exact url without `{values}`
 *   url: 'https://static.{envExceptNp}.playstation.com/images/{version}/',
 * });
 * ```
 *
 * Basic usage
 *
 * ```jsx
 * <Image
 *   src="https://my-image-host.com/image-1.png"
 *   alt="description of my image"
 * />
 *```
 *
 * Image with fallback image
 *
 * ```jsx
 * <Image
 *   aspectRatio="1:1"
 *   src="https://my-image-host.com/image-1.png"
 *   alt="description of my image"
 * >
 *   <Image
 *     src="https://my-image-host.com/fallback-1.webp"
 *     alt="image could not load"
 *   />
 * </Image>
 *```
 * Image with a fallback icon
 *
 *```jsx
 * <Image
 *   aspectRatio="1:1"
 *   src="https://my-image-host.com/image-1.png"
 *   alt="description of my image"
 * >
 *   <Icon
 *     className="psw-center"
 *     type="error"
 *     label="image could not load"
 *   />
 * </Image>
 *```
 *
 * ## Props
 */


var Image = /*#__PURE__*/function (_PureComponent) {
  _inherits(Image, _PureComponent);

  var _super = _createSuper(Image);

  function Image(props) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null,
      src: null,
      isLoaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (error) {
      var onError = _this.props.onError;

      _this.setState({
        error: error
      });

      onError(error);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoad", function (event) {
      var _this$props = _this.props,
          src = _this$props.src,
          onLoad = _this$props.onLoad;

      _this.setState({
        isLoaded: true,
        src: src
      });

      onLoad(event);
    });

    var forwardedRef = _this.props.forwardedRef;
    _this.node = forwardedRef || /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // This forced render is to make sure we can get the height of the ref or the parents
      // height to make a best guess as to the image width to pull down from Akamai image manager
      // eslint-disable-next-line
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "_getWidth",

    /**
     * Get the width in pixels as a number to use when requesting the image from akamai image
     * manager.
     */
    value: function _getWidth() {
      var width = this.props.width;
      var ref = this.node.current;
      if (!ref) return width;
      var widthToUse = width || getComputedStyle(ref).getPropertyValue('width');
      if (isPx(widthToUse)) return resolvePxWidth(widthToUse);
      if (isVw(widthToUse)) return getPxWidthFromVw(widthToUse);
      var parentWidthInPx = getFirstNonZeroParentWidth(ref.parentElement);
      if (isPercentage(widthToUse)) return getPxWidthFromPercent(parentWidthInPx, widthToUse);
      return parentWidthInPx;
    }
  }, {
    key: "_getFullSrc",
    value: function _getFullSrc() {
      var _this$props2 = this.props,
          src = _this$props2.src,
          useStatic = _this$props2.useStatic;
      return useStatic ? getStaticImageSrc(src, Image.config) : src;
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      var _this$state = this.state,
          isLoaded = _this$state.isLoaded,
          src = _this$state.src;
      var srcProp = this.props.src;
      return isLoaded && src === srcProp;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          place = _this$props3.place,
          fit = _this$props3.fit,
          alt = _this$props3.alt,
          children = _this$props3.children,
          qa = _this$props3.qa,
          loading = _this$props3.loading,
          widthProp = _this$props3.width,
          aspectRatio = _this$props3.aspectRatio,
          height = _this$props3.height,
          dataTelemetryMeta = _this$props3.dataTelemetryMeta,
          dataTrackContent = _this$props3.dataTrackContent;
      var error = this.state.error;

      var width = this._getWidth();

      var fullSrc = this._getFullSrc();

      var _getImageUrl = getImageUrl(fullSrc, {
        width: width,
        npEnvironment: Image.config.npEnvironment
      }),
          previewSrc = _getImageUrl.previewSrc,
          fullResolvedSrc = _getImageUrl.src,
          srcset = _getImageUrl.srcset;

      var hasPreview = !!previewSrc;

      var _Image$getClassName = Image.getClassName({
        className: className,
        place: place,
        fit: fit,
        hasPreview: hasPreview,
        isLoaded: this.isLoaded()
      }),
          root = _Image$getClassName.root,
          preview = _Image$getClassName.preview,
          image = _Image$getClassName.image,
          noScriptClass = _Image$getClassName.noScriptClass;

      var useWidth = widthProp;
      var shouldRenderFull = Image.config.isSsr ? hasPreview && widthProp && !isPercentage(widthProp) || !hasPreview : !!width || !hasPreview;
      return /*#__PURE__*/React.createElement(MediaFrame, {
        qa: qa,
        ref: this.node,
        aspectRatio: aspectRatio,
        place: place,
        fit: fit,
        width: useWidth,
        height: height,
        className: root,
        "data-telemetry-meta": dataTelemetryMeta,
        "data-track-content": dataTrackContent
      }, !error && previewSrc && /*#__PURE__*/React.createElement("img", {
        "aria-hidden": true,
        loading: loading,
        "data-qa": "".concat(qa, "#preview"),
        alt: alt,
        className: preview,
        src: previewSrc
      }), shouldRenderFull && !error && fullResolvedSrc && /*#__PURE__*/React.createElement("img", {
        loading: loading,
        "data-qa": "".concat(qa, "#image"),
        alt: alt,
        className: image,
        src: fullResolvedSrc,
        srcSet: srcset,
        onError: this.handleError,
        onLoad: this.handleLoad
      }), error && children, /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement("img", {
        className: noScriptClass,
        loading: loading,
        "data-qa": "".concat(qa, "#image-no-js"),
        alt: alt,
        src: fullSrc
      })));
    }
  }]);

  return Image;
}(PureComponent);

Image.mediaFrame = true;
Image.config = {
  isSsr: (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object',
  npEnvironment: 'e1-np',
  version: 'v0',
  // image manager url
  // url: 'https://image.{envExceptNp}.api.playstation.com/static/{lineBucket}/public/images/{version}/',
  url: 'https://static.{envExceptNp}.playstation.com/images/{version}/'
};

Image.isImage = function (_ref) {
  var src = _ref.src,
      type = _ref.type;
  var srcPath = (src || '').split('?')[0];

  var isImageFile = function isImageFile(x) {
    return /(.jpg|.jpeg|.webp|.png|.gif|.svg)$/i.test(x);
  };

  var isBase64Image = /^data:image\/\w+;base64/.test(src);
  return type === 'image' || isImageFile(srcPath) || isImageFile(src) || isBase64Image;
};

Image.configure = function (config) {
  Image.config = _objectSpread(_objectSpread({}, Image.config), config);
};

Image.defaultProps = {
  qa: '',
  src: null,
  place: 'center',
  fit: 'cover',
  className: '',
  width: undefined,
  height: undefined,
  children: null,
  useStatic: false,
  aspectRatio: '16:9',
  loading: 'lazy',
  onLoad: function onLoad() {},
  onError: function onError() {},
  forwardedRef: null,
  dataTelemetryMeta: null,
  dataTrackContent: null
};
Image.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * The image source to use, same usage as img element
   */
  src: PropTypes.string,

  /**
   * Alternative text for visually impaired users
   */
  alt: PropTypes.string.isRequired,

  /**
   * HTML5 attribute for how to load the image
   * [MDN Docs on loadding attr](https://developer.mozilla.org/en-US/docs/Web/Performance/Lazy_loading)
   */
  loading: PropTypes.oneOf(['lazy', 'auto', 'eager']),

  /**
   * How to fit the image when aspect ratios are mismatched
   * values generally follow the `background-size` css property
   * [MDN Dos on background-size](https://developer.mozilla.org/en-US/docs/Web/CSS/background-size)
   */
  fit: PropTypes.oneOf(['cover', 'contain', 'fill']),

  /**
   * Strategy for placing the image within it's frame
   */
  place: PropTypes.oneOf(['center', 'right-center', 'right-top-third', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),

  /**
   * Aspect ratio to restrict the image to. Aspect ratios are defined in
   * the base styles package
   */
  aspectRatio: PropTypes.oneOf([undefined, '1:1', '4:3', '20:9', '16:9', '3:2', '2:3', '3:4', '8:5', '4:5', '5:6']),

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Sets the width of the image to display
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Sets the height of the image to display
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * fallback component to render on error
   */
  children: PropTypes.node,

  /**
   * Whether the image is hosted on static.playstation.com
   */
  useStatic: PropTypes.bool,

  /**
   * Callback prop called when the full image is loaded
   */
  onLoad: PropTypes.func,

  /**
   * Callback prop called when the full image could not be loaded due to an error
   */
  onError: PropTypes.func,

  /**
   * Data attribute read by web-common-telemetry to add any metadata to be sent to the spec
   * factories
   */
  dataTelemetryMeta: PropTypes.string,

  /**
   * Data attribute read by web-common-telemetry to tag this element for tracking impressions
   */
  dataTrackContent: PropTypes.string,

  /**
   * Forwarded ref attached to the image container element
   */
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
};

Image.getClassName = function (_ref2) {
  var className = _ref2.className,
      isLoaded = _ref2.isLoaded,
      hasPreview = _ref2.hasPreview,
      fit = _ref2.fit,
      place = _ref2.place;
  var sizeAndPosition = cx("psw-".concat(place), "psw-l-fit-".concat(fit));
  return {
    root: cx('psw-image', className),
    preview: cx({
      'psw-blur': !isLoaded
    }, {
      'psw-fade-out': isLoaded
    }, sizeAndPosition),
    image: cx({
      'psw-visually-hide': hasPreview && !isLoaded
    }, {
      'psw-fade-in': isLoaded
    }, sizeAndPosition),
    noScriptClass: sizeAndPosition
  };
};

Image.useClassNames = function (x) {
  Image.classNames = x;
};

cx = classNamesFor(Image);
export default Image;